module.exports = "https://img1.huilianyi.com/7/no-print-en.75dcce8c90.appcore.png";